import { queryClient } from '../queryClient';
import { QUERIES } from '../utils/constants';
import { workflowStepMap, workflowTaskMap } from './schema';
import {
  getRetailerSettingsQueryFn,
  type GetRetailerSettingsResult,
} from '../graphql/query/getRetailerSettings';
import type { Workflow } from './schemaTypes';

const fetchRetailerSettings = async () => {
  const { retailerSettings } =
    await queryClient.fetchQuery<GetRetailerSettingsResult>({
      queryKey: [QUERIES.GET_RETAILER_SETTINGS],
      queryFn: getRetailerSettingsQueryFn,
      gcTime: Infinity,
    });
  return retailerSettings;
};

export const getConfig = async () => {
  const retailerSettings = await fetchRetailerSettings();

  // Once we fetch the config, we need to map the tasks and steps to produce actual workflow.
  const config: Workflow = {
    steps: retailerSettings.workflow.map((stepConfig) => {
      const { id, tasks } = stepConfig;
      const step = workflowStepMap[id];
      const stepTasks = tasks.map((task) => {
        const workflowTask = {
          ...workflowTaskMap[task.id],
          guards: task.guards,
          mode: task.mode,
          scope: task.scope,
          conditions: task.conditions,
        };
        return workflowTask;
      });

      return {
        ...step,
        tasks: stepTasks,
      };
    }),
  };

  return { config, retailerSettings };
};
